import { Box, Button, Container, Grid } from "@mui/material";
import React, { useMemo } from "react";
import { LinkBtn, LinkBtnProps } from "./lnk-btn";
import { HeavyCard, HeavyCardProps } from "./heavy-card";

export interface ButtonPanelProps extends HeavyCardProps {
  next: LinkBtnProps;
  back?: LinkBtnProps;
}
export const ButtonPanel = ({ next, back, ...heavyCard }: ButtonPanelProps) => {
  const _back = useMemo((): LinkBtnProps | undefined => {
    if (!back) {
      return undefined;
    }
    return {
      label: "Back",
      variant: "outlined",
      icon: "back",
      color: "interface",
      ...back,
    };
  }, [back]);
  const _next = useMemo((): LinkBtnProps | undefined => {
    if (!next) {
      return undefined;
    }
    return {
      label: "Next",
      variant: "contained",
      icon: "next",
      color: "interface",
      fullWidth: true,
      ...next,
    };
  }, [next]);
  return (
    <>
      <Box sx={{
        width: '100%',
        height: 100
      }}></Box>
      <Box sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        background: "#EEE",
        borderTop: "1px solid #AAA"
      }}>
        <Container maxWidth="md" sx={{ my: 2, }}>

          <HeavyCard>
            <Box display="flex" justifyContent="space-between">

              <Box>{_back ? <LinkBtn {..._back} /> : null}</Box>

              <Box marginLeft={4} display="flex" width="100%">
                <LinkBtn {..._next} />
              </Box>
            </Box>
          </HeavyCard>
        </Container>
      </Box>
    </>
  );
};
